(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ThumbnailatorController', ThumbnailatorController);

    ThumbnailatorController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity',
    'CommonService', 'Qinius', 'Base64Image'];

    function ThumbnailatorController( $scope, Category, $uibModalInstance, MessageService,entity,
     CommonService, Qinius, Base64Image) {

        var vm = this;
        // vm.isEnd = true;
        vm.files = entity.files;
        vm.folderId = entity.folderId;
        vm.aid = entity.aid;
        vm.token = entity.token;
        $scope.domain = entity.domain;

        $scope.photos = [];

        angular.forEach(vm.files,function (f) {
            // 先用原始 blob URL 作为默认值，避免 ng-src 为空
            f.blobCover = URL.createObjectURL(f);
            // 异步生成缩略图，成功后替换为大图中的第一帧缩略图
            createThumbnailBlob(f, 400, 400, function(thumbnailUrl) {
                if (thumbnailUrl) {
                    f.blobCover = thumbnailUrl;
                    $scope.$apply();
                }
            });
        })

        /**
         * 将图片文件缩小到指定尺寸，避免原图过大导致浏览器解码失败显示破图
         * 使用 URL.createObjectURL 加载原图（零拷贝），解码后通过 Canvas 缩放到指定尺寸
         */
        function createThumbnailBlob(file, maxWidth, maxHeight, callback) {
            var objectUrl = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function() {
                var width = img.width;
                var height = img.height;

                // 只在原图超出限制时才缩放
                if (width > maxWidth || height > maxHeight) {
                    var ratio = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * ratio);
                    height = Math.round(height * ratio);

                    var canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(function(blob) {
                        URL.revokeObjectURL(objectUrl);
                        if (blob) {
                            callback(URL.createObjectURL(blob));
                        } else {
                            callback(null); // toBlob 失败则不替换
                        }
                    }, file.type || 'image/jpeg');
                } else {
                    // 图片尺寸在限制内，无需替换
                    URL.revokeObjectURL(objectUrl);
                    callback(null);
                }
            };
            img.onerror = function() {
                // 解码失败，保持原始 blob URL
                URL.revokeObjectURL(objectUrl);
                callback(null);
            };
            img.src = objectUrl;
        }

        vm.clear = clear;
        vm.save = save;

        $scope.deletePic = function ($index) {
            vm.files.splice($index,1)
        }

        function blobToFile(theBlob, fileName) {
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        };

        $scope.compression = function () {
            vm.loading = true;
            var f = 0;
            angular.forEach(vm.files,function (file,i) {
                var img = new  Image();
                img.src = file.blobCover;
                Base64Image.compress(file.blobCover, img.height, 0.9, function(newBase64) {
                    var compressedSize = Base64Image.getSize(newBase64);
                    var blob = dataURLtoBlob(newBase64);
                    var aasfile = blobToFile(blob, file["name"]);
                    var aafile = new File([aasfile], file["name"], { type: file["type"] });
                    console.log("compress: " + file.size + " ==> " + aafile.size);

                    CommonService.UpdateQiniuService([aafile], 0, 1, $scope.domain, vm.token, vm.folderId,vm.aid,function (resp) {
                        file.lowerSize = Math.ceil(compressedSize/1024/1024);
                        file.newSize = compressedSize;

                        // var arr = resp.data;
                        // var identifier = angular.copy(arr.identifier)
                        // arr.identifier = $scope.domain + arr.identifier;
                        // arr.usenum = 0;
                        // arr.imgsize = arr.imgSize;
                        // $scope.photos.unshift(arr);
                        i++;
                        if(i == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    }, function(){
                        i++;
                        if(i == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    })
                });

            })
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            console.log($scope.photos)
            $uibModalInstance.close($scope.photos);
            vm.isSaving = false;
            // onSaveSuccess(vm.files);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();
